import { render, staticRenderFns } from "./PluginsDefault.vue?vue&type=template&id=1ef82e63"
import script from "./PluginsDefault.vue?vue&type=script&lang=ts"
export * from "./PluginsDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef82e63')) {
      api.createRecord('1ef82e63', component.options)
    } else {
      api.reload('1ef82e63', component.options)
    }
    module.hot.accept("./PluginsDefault.vue?vue&type=template&id=1ef82e63", function () {
      api.rerender('1ef82e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/PluginsDefault.vue"
export default component.exports